<template>
  <div class="aco-info-box">
    <b-overlay :show="this.loading" rounded="sm">
      <fieldset :disabled="loading">
        <b-col class="aco-details">
          <b-form>
            <h3>{{ $t('licenses') }}</h3>
            <b-row class="aco-details-row">
              <b-col>
                <b-row class="aco-details-row">
                  <b-col md="2">
                    {{ $t('licenseReport') }}
                  </b-col>
                  <b-col md="2">
                    <b-button href="#" size="sm" variant="outline-success" @click.native="downloadReport('license/validate')">
                      {{ $t('download') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <h3>{{ $t('products') }}</h3>
            <b-row class="aco-details-row">
              <b-col>
                <b-row class="aco-details-row">
                  <b-col md="2">
                    {{ $t('productReport') }}
                  </b-col>
                  <b-col md="2">
                    <b-button href="#" size="sm" variant="outline-success" @click.native="downloadReport('product/validate')">
                      {{ $t('download') }}
                    </b-button>
                  </b-col>
                </b-row>
                <b-row class="aco-details-row">
                  <b-col md="2">
                    {{ $t('allProducts') }}
                  </b-col>
                  <b-col md="2">
                    <b-button href="#" size="sm" variant="outline-success" @click.native="downloadReport('product/export', { trimLongStrings: true })">
                      {{ $t('downloadShortened') }}
                    </b-button>
                  </b-col>
                  <b-col md="2">
                    <b-button href="#" size="sm" variant="outline-success" @click.native="downloadReport('product/export', { trimLongStrings: false })">
                      {{ $t('downloadFull') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <h3>{{ $t('organizations') }}</h3>
            <b-row class="aco-details-row">
              <b-col>
                <b-row class="aco-details-row">
                  <b-col md="2">
                    {{ $t('downloadPartnerCustomerReport') }}
                  </b-col>
                  <b-col md="2">
                    <b-button href="#" size="sm" variant="outline-success" @click.native="downloadReport('partner/customers')">
                      {{ $t('download') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>

            <h3>{{ $t('unibok') }}</h3>
            <b-row class="aco-details-row">
              <b-col>
                <b-row class="aco-details-row">
                  <b-col md="2">
                    {{ $t('downloadUnibokExport') }}
                  </b-col>
                  <b-col md="2">
                    <b-button href="#" size="sm" variant="outline-success" @click.native="downloadUnibokReport()">
                      {{ $t('download') }}
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-col>
      </fieldset>
    </b-overlay>
  </div>
</template>

<script>
  import ReportService from '../../services/ReportService'
  import BaseComponent from '../../components/BaseComponent'

  export default {
    name: 'ReportView',
    extends: BaseComponent,

    data () {
      return {
        loading: false,
        productValidation: null
      }
    },
    methods: {
      downloadReport (report, params) {
        this.loading = true
        ReportService.downloadReport(report, params)
          .catch(e => {
            throw e
          })
          .finally(() => this.loading = false)

      },
      downloadUnibokReport () {
        this.loading = true
        this.downloadFile(process.env.VUE_APP_EXTERNAL_API_BASEURL + '/test/unibok/fetch', 'unibok.json')
          .catch(e => {
            throw e
          })
          .finally(() => this.loading = false)
      }
    },
    i18n: {
      messages: {
        en: {
          'licenseReport': 'License report',
          'licenseOveruse': 'License overuse',
          'overuseReport': 'Report for license overuse',
          'productReport': 'Product report',
          'allProducts': 'All products as CSV',
          'downloadShortened': 'Download with shortened texts',
          'downloadFull': 'Download with full texts',
          'downloadUnibokExport': 'Download Unibok product catalogue data',
          'downloadPartnerCustomerReport': 'Download partner customer report'
        },
        nb: {
          'licenseReport': 'Lisensrapport',
          'licenseOveruse': 'Lisens overforbruk',
          'overuseReport': 'Rapport over lisensoverforbruk',
          'productReport': 'Produktrapport',
          'allProducts': 'Alle produkter som CSV',
          'downloadShortened': 'Last ned med forkortede tekstfelter',
          'downloadFull': 'Last ned med hele tekstfelter',
          'downloadUnibokExport': 'Last ned Unibok produktkatalog',
          'downloadPartnerCustomerReport': 'Last ned kunderapport'
        }
      }
    }
  }
</script>
